var _radialGradient, _radialGradient2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    viewBox: "0 0 170.55 506.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 159.49,
    cy: 168.12,
    r: 30.638,
    gradientTransform: "scale(.66368 1.5067)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b3b3eb",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "b",
    cx: 85.528,
    cy: 170.15,
    r: 252.09,
    gradientTransform: "matrix(.72966 0 0 1.3705 -32.308 -6.995)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "c",
    cx: 193.4,
    cy: 181.62,
    r: 68.144,
    gradientTransform: "scale(.67783 1.4753)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#333"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 193.63,
    x2: 193.63,
    y1: 161.65,
    y2: 162.42,
    gradientTransform: "scale(.66368 1.5067)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M86.442 184.5c45.63-125-85-49.38-36.875-180.63",
    style: {
      stroke: "#4c4c4c",
      strokeWidth: 7.75,
      strokeLinecap: "square",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.292 505.94c-73.244 0-84.317-65.02-83.559-85.62 1.127-19.43 2.065-97.59-1.17-163.4.824-71.92 55.773-70.2 84.709-70.2 28.94 0 83.89-1.72 84.72 70.2-3.24 65.81-2.3 143.97-1.17 163.4.75 20.6-10.32 85.61-83.56 85.61",
    style: {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.125,
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.75 254.93a15.938 34.688 0 1 1-31.875 0 15.938 34.688 0 1 1 31.875 0z",
    style: {
      fillRule: "evenodd",
      fill: "url(#c)"
    },
    transform: "matrix(.98039 0 0 1.2432 -30.311 -69.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.262 187.14v118.58",
    style: {
      stroke: "#000",
      strokeWidth: 1.25,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.38 257.12a11.562 26.25 0 1 1-23.125 0 11.562 26.25 0 1 1 23.125 0z",
    style: {
      fillRule: "evenodd",
      fill: "url(#d)"
    },
    transform: "translate(-32.308 -10.12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.38 257.12a11.562 26.25 0 1 1-23.125 0 11.562 26.25 0 1 1 23.125 0z",
    style: {
      fillRule: "evenodd",
      fill: "url(#e)"
    },
    transform: "translate(-32.308 -10.12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.052 305.66c-82.348 0-80.164 3.3-82.625 3.92M85.262 305.66c83.17 0 82.89 4.67 82.89 4.67",
    style: {
      stroke: "#000",
      strokeWidth: 1.25,
      strokeLinecap: "round",
      fill: "none"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.2bf59a9027e1be7f0da43618df28c8f2.svg";
export { ForwardRef as ReactComponent };